import { render } from "./limitedTextarea.vue?vue&type=template&id=3d72fa14&ts=true"
import script from "./limitedTextarea.ts?vue&type=script&lang=ts"
export * from "./limitedTextarea.ts?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__